import { MenuModel } from '@bo-client/core/navigation/menu.model';

export enum UserMenuActionEnum {
  changeProfile = 'changeProfile',
  changePassword = 'changePassword',
  logout = 'logout'
}

export const UserMenu: MenuModel[] = [
  {
    label: 'Passwort ändern',
    icon: null,
    action: UserMenuActionEnum.changePassword,
    roles: ['ALL_USERS']
  },
  {
    label: 'Profil bearbeiten',
    icon: null,
    action: UserMenuActionEnum.changeProfile,
    roles: ['ALL_USERS']
  },
  {
    label: 'Logout',
    icon: 'logout',
    action: UserMenuActionEnum.logout,
    roles: ['ALL_USERS']
  }
];
